import InvoiceInfo from './InvoiceInfo'
export default InvoiceInfo
